import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import useUserData from 'data-hooks/useUserData';
import { LOGOUT } from 'mocks/mutations';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';

import IconHeart2 from 'components/icons/iconHeart2';
import IconBag from 'components/icons/IconBag';
import IconUserAccount from 'components/icons/iconUserAccount';
import ToolbarIconButton from 'components/consumer/ToolbarIconButton';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import HeaderToolbarDropdown from './HeaderToolbarDropdownButton';

const HeaderToolbarUI = ({
  bagCount,
  favoriteCount,
  accountTo,
  onBagClick = () => {},
  onWishlistClick = () => {},
}) => {
  const { isLoggedIn, firstName, email } = useUserData();

  const [logout] = useMutation(LOGOUT);
  const logoutClient = useLogoutClient();

  const onLogoutClick = async () => {
    await logout();
    logoutClient();
    window.location.replace('/');
  };

  return (
    <div className="flex relative right-[-10px] [&>*]:ml-[2px] [&>*:first-child]:ml-0">
      <MobileAndTabletOnly>
        <ToolbarIconButton
          data-xc="account"
          icon={IconUserAccount}
          to={accountTo}
          title="Account"
          className="lg:hidden"
        />
      </MobileAndTabletOnly>

      <DesktopOnly>
        <HeaderToolbarDropdown
          data-xc="user-account"
          icon={IconUserAccount}
          title="User Account"
          dropdownItems={[
            {
              text: isLoggedIn ? `Hi, ${firstName}` : 'Log In',
              subtext: isLoggedIn ? `${email}` : '',
              link: '/customer/dashboard/',
            },
            {
              text: 'My Account',
              link: '/customer/dashboard/',
            },
            {
              text: 'My Orders',
              link: '/customer/orders/',
            },
            {
              text: 'Contact Us',
              link: '/contact-us/',
            },
            ...(isLoggedIn
              ? [
                  {
                    text: 'Sign out',
                    onClick: onLogoutClick,
                  },
                ]
              : []),
          ]}
        />
      </DesktopOnly>

      <ToolbarIconButton
        badgeColor="red"
        count={favoriteCount}
        data-xc="wishlist"
        icon={IconHeart2}
        onClick={onWishlistClick}
        title="Wishlist"
        to="/wishlist/"
      />
      <ToolbarIconButton
        badgeColor="brand"
        count={bagCount}
        data-xc="cart"
        icon={IconBag}
        onClick={onBagClick}
        title="Bag"
      />
    </div>
  );
};

HeaderToolbarUI.propTypes = {
  bagCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  favoriteCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  accountTo: PropTypes.string,
  onBagClick: PropTypes.func,
  onWishlistClick: PropTypes.func,
};

export default HeaderToolbarUI;
